import React from "react";

/**
 * Banner de acceso solo-lectura (tenencia finalizada).
 * Extraído del shell de App.js para compartir entre las ramas mobile y desktop.
 */
const ReadOnlyBanner = ({ unit }) => (
  <div
    style={{
      background: "#FEF3C7",
      color: "#92400E",
      borderBottom: "1px solid #FCD34D",
      padding: "10px 20px",
      fontSize: 13,
      lineHeight: 1.5,
    }}
  >
    Acceso de <b>solo lectura</b>: tu tenencia en{" "}
    <b>{unit?.number ? `la unidad ${unit.number}` : "esta unidad"}</b> finalizó.
    Podés ver tu histórico y saldar los pagos pendientes, pero no realizar acciones nuevas.
  </div>
);

export default ReadOnlyBanner;
